export const PRODUCT_PACK_ROUTE_PATHS = {
  productPack: '/cards/debit-card-product-pack',
};

export const PRODUCT_PACK_API_PATHS = {
  whitelist: '/v1/api/debit-card/whitelist',
  whitelistInsert: '/v1/api/debit-card/whitelist/insert',
  whitelistRemove: '/v1/api/debit-card/whitelist/remove',
  whitelistBulk: '/v1/api/debit-card/whitelist/bulk',
  productPacks: '/v1/api/debit-card/product-packs',
  productPackCreate: '/v1/api/debit-card/product-packs/create',
  productPackDelete: '/v1/api/debit-card/product-packs/delete',
  productPackEnable: '/v1/api/debit-card/product-packs/enable',
  productPackDisable: '/v1/api/debit-card/product-packs/disable',
  skins: '/v1/api/debit-card/skins',
  skinsCreate: '/v1/api/debit-card/skins/create',
  segments: '/v1/api/debit-card/segments',
  segmentsCreate: '/v1/api/debit-card/segments/create',
  segmentsEdit: '/v1/api/debit-card/segments/edit',
  segmentGroups: '/v1/api/debit-card/segments/groups',
  segmentGroupsCreate: '/v1/api/debit-card/segments/groups/create',
};
